import { axiosInstance } from "./config";

const BASE_URL = "/candidate";

export const createCandidate = (data) =>
  axiosInstance.post(`${BASE_URL}/create`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const getAllCandidates = (
  page = 1,
  limit = 10,
  location = "",
  search = ""       
) =>
  axiosInstance.get(
    `${BASE_URL}/all?page=${page}&limit=${limit}&location=${location}&search=${search}`
  );

export const getCandidateById = (id) =>
  axiosInstance.get(`${BASE_URL}/${id}`);

export const updateCandidate = (id, data) =>
  axiosInstance.put(`${BASE_URL}/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const approveCandidate = (id, payload) =>
  axiosInstance.put(`/candidate/approve/${id}`, payload, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteCandidate = (id) =>
  axiosInstance.delete(`${BASE_URL}/${id}`);

export const exportCandidates = (fromDate, toDate) =>
axiosInstance.get(
    `${BASE_URL}/export?fromDate=${fromDate}&toDate=${toDate}`,
    {
      responseType: "blob",
      timeout: 0,
    }
  );

export const checkAadhar = (aadharNumber) =>
axiosInstance.get(`${BASE_URL}/check-aadhar/${aadharNumber}`);

export const getCandidatesByBranch = (
  branchId,
  page = 1,
  limit = 50
) =>
axiosInstance.get(
    `/candidate/all?page=${page}&limit=${limit}&branch=${branchId}`
  );
 
export const getProjectWiseCount = () =>
  axiosInstance.get("/candidate/project-count");
 
export const getProgramWiseCount = (project) =>
  axiosInstance.get(`/candidate/program-count?project=${project}`);